import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { IlsModelService } from '../../shared/services/ils-model.service'
import { SendLogActionService } from '../../shared/services/send-log-action.service'
import { PhaseWithContent } from '@monorepo/golab-generated'
import { NgClass } from '@angular/common'

@Component({
  selector: 'app-phase-list',
  templateUrl: './phase-list.component.html',
  styleUrls: ['./phase-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class PhaseListComponent {
  private ilsModelService = inject(IlsModelService);
  private sendLogActionService = inject(SendLogActionService);


  get phases(): PhaseWithContent[] {
    return this.ilsModelService.phaseList
  }

  get currentPhaseId(): string {
    return this.ilsModelService.currentPhaseId
  }

  selectPhase(id: string) {
    // console.log(`selectPhase(${id})`)
    if (this.currentPhaseId) {
      this.sendLogActionService.sendLeavePhaseAction()
    }
    this.ilsModelService.currentPhaseId = id
    this.sendLogActionService.sendEnterPhaseAction()
  }
}
